import Icon from './Icon';

export default Icon;
export {default as Facebook} from './Social/Facebook';
export {default as Instagram} from './Social/Instagram';
export {default as LinkedIn} from './Social/LinkedIn';
export {default as HamburgerMenu} from './Main/HamburgerMenu';
